import {GET_FEEDBACK_DOCUMENTS_LIST,GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS,GET_FEEDBACK_DOCUMENTS_LIST_FAILED,
SUBMIT_DOCUMENTS_LIST,SUBMIT_DOCUMENTS_LIST_SUCCESS,SUBMIT_DOCUMENTS_LIST_FAILED} from "./actionTypes"
//submit document
export const getDocumentList = (code)=>{
    return {
        type: GET_FEEDBACK_DOCUMENTS_LIST,
        payload: {code}
    }
} 

export const getDocumentListSuccess = (data)=>{
    return {
        type: GET_FEEDBACK_DOCUMENTS_LIST_SUCCESS,
        payload: {data}
    }
} 

export const getDocumentListFail = (message)=>{
    return {
        type: GET_FEEDBACK_DOCUMENTS_LIST_FAILED,
        payload: {message}
    }
} 

export const submitDocumentList = (jsonData)=>{
    return {
        type: SUBMIT_DOCUMENTS_LIST,
        payload: {jsonData}
    }
} 

export const submitDocumentListSuccess = (message)=>{
    return {
        type: SUBMIT_DOCUMENTS_LIST_SUCCESS,
        payload: {message}
    }
} 

export const submitDocumentListFail = (message)=>{
    return {
        type: SUBMIT_DOCUMENTS_LIST_FAILED,
        payload: {message}
    }
} 
